(function () {
  const initializedSections = new WeakSet();

  function injectStyles() {
    if (document.getElementById('lookbook-lightbox-styles')) return;

    const style = document.createElement('style');
    style.id = 'lookbook-lightbox-styles';
    style.textContent = `
      .lookbook-lightbox {
        align-items: center;
        background: rgb(0 0 0 / 0.88);
        border: 0;
        box-sizing: border-box;
        color: #fff;
        height: 100%;
        inset: 0;
        justify-content: center;
        margin: 0;
        max-height: none;
        max-width: none;
        padding: clamp(16px, 3vw, 40px);
        position: fixed;
        width: 100%;
        z-index: 9999;
      }

      .lookbook-lightbox[open] {
        display: flex;
      }

      .lookbook-lightbox::backdrop {
        background: rgb(0 0 0 / 0.88);
      }

      .lookbook-lightbox__image {
        display: block;
        max-height: calc(100vh - 120px);
        max-width: min(100%, 1200px);
        object-fit: contain;
      }

      .lookbook-lightbox__button {
        align-items: center;
        appearance: none;
        background: rgb(255 255 255 / 0.14);
        border: 1px solid rgb(255 255 255 / 0.28);
        border-radius: 999px;
        color: inherit;
        cursor: pointer;
        display: flex;
        font: inherit;
        height: 44px;
        justify-content: center;
        padding: 0;
        position: absolute;
        transition: background var(--animation-speed-fast, 150ms) ease;
        width: 44px;
      }

      .lookbook-lightbox__button:hover,
      .lookbook-lightbox__button:focus-visible {
        background: rgb(255 255 255 / 0.24);
      }

      .lookbook-lightbox__close {
        right: clamp(16px, 3vw, 32px);
        top: clamp(16px, 3vw, 32px);
      }

      .lookbook-lightbox__previous {
        left: clamp(16px, 3vw, 32px);
        top: 50%;
        transform: translateY(-50%);
      }

      .lookbook-lightbox__next {
        right: clamp(16px, 3vw, 32px);
        top: 50%;
        transform: translateY(-50%);
      }

      .lookbook-lightbox__counter {
        bottom: clamp(16px, 3vw, 32px);
        font-size: 0.875rem;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
      }

      @media screen and (max-width: 749px) {
        .lookbook-lightbox__image {
          max-height: calc(100vh - 96px);
        }

        .lookbook-lightbox__previous,
        .lookbook-lightbox__next {
          bottom: 16px;
          top: auto;
          transform: none;
        }

        .lookbook-lightbox__previous {
          left: 16px;
        }

        .lookbook-lightbox__next {
          right: 16px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function imageSource(image) {
    return image.currentSrc || image.src;
  }

  function createLightbox(images) {
    const dialog = document.createElement('dialog');
    dialog.className = 'lookbook-lightbox';
    dialog.setAttribute('aria-label', 'Lookbook image viewer');
    dialog.innerHTML = `
      <button class="lookbook-lightbox__button lookbook-lightbox__close" type="button" aria-label="Close">&times;</button>
      <button class="lookbook-lightbox__button lookbook-lightbox__previous" type="button" aria-label="Previous image">&#8249;</button>
      <img class="lookbook-lightbox__image" alt="">
      <button class="lookbook-lightbox__button lookbook-lightbox__next" type="button" aria-label="Next image">&#8250;</button>
      <div class="lookbook-lightbox__counter" aria-live="polite"></div>
    `;

    const image = dialog.querySelector('.lookbook-lightbox__image');
    const counter = dialog.querySelector('.lookbook-lightbox__counter');
    const closeButton = dialog.querySelector('.lookbook-lightbox__close');
    const previousButton = dialog.querySelector('.lookbook-lightbox__previous');
    const nextButton = dialog.querySelector('.lookbook-lightbox__next');
    let activeIndex = 0;

    function show(index) {
      activeIndex = (index + images.length) % images.length;
      const activeImage = images[activeIndex];
      image.src = imageSource(activeImage);
      image.alt = activeImage.alt || '';
      counter.textContent = `${activeIndex + 1} / ${images.length}`;
    }

    function open(index) {
      show(index);
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function close() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    closeButton.addEventListener('click', close);
    previousButton.addEventListener('click', () => show(activeIndex - 1));
    nextButton.addEventListener('click', () => show(activeIndex + 1));

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(activeIndex - 1);
      if (event.key === 'ArrowRight') show(activeIndex + 1);
    });

    document.body.appendChild(dialog);

    return { open };
  }

  function initSection(marker) {
    const section = marker.closest('.section');
    if (!section || initializedSections.has(section)) return;

    const images = Array.from(section.querySelectorAll('.image-block img')).filter((image) => imageSource(image));
    if (!images.length) return;

    initializedSections.add(section);
    const lightbox = createLightbox(images);

    images.forEach((image, index) => {
      const trigger = image.closest('a, .image-block') || image;
      trigger.style.cursor = 'zoom-in';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        lightbox.open(index);
      });
    });
  }

  function init() {
    injectStyles();
    document.querySelectorAll('[data-lookbook-lightbox]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
